import React from 'react';
import { useNavigate } from 'react-router-dom';
import './InfoPages.css';

function PublicSiteFooter() {
  const navigate = useNavigate();

  return (
    <footer className="public-site-footer">
      <div className="public-site-footer-shell">
        <div className="public-site-footer-brand">
          <span>Redact</span>
          <span>Ø</span>
        </div>
        <p className="public-site-footer-copy">
          Secure document redaction for teams that need clean workflows, trustworthy controls, and modern compliance signals.
        </p>
        <div className="public-site-footer-links">
          <button type="button" onClick={() => navigate('/privacy-policy')}>Privacy</button>
          <button type="button" onClick={() => navigate('/terms')}>Terms</button>
          <button type="button" onClick={() => navigate('/user-agreement')}>User Agreement</button>
          <button type="button" onClick={() => navigate('/billing-refunds')}>Billing</button>
          <button type="button" onClick={() => navigate('/support')}>Support</button>
          <button type="button" onClick={() => navigate('/contact')}>Contact</button>
        </div>
      </div>
    </footer>
  );
}

export default PublicSiteFooter;
